import Config from "@app/constants/Config";
import localforage from "localforage";
import { getSetting } from "@app/models/settings";
import { authMiddleware } from "@app/utils/helper";
import { OutdatedError } from "@app/lib/errors/OutdatedError";

const store = localforage.createInstance({
	name: "userOffices",
});

// Use for testing the spinner
// function Sleep(milliseconds) {
// 	return new Promise(resolve => setTimeout(resolve, milliseconds));
// }

async function loadOffices() {
	const response = await fetch(Config.API.USER_OFFICES.LOAD, {
		credentials: "include",
	});
	await authMiddleware(response);
	// await Sleep(1000) // Use for testing the spinner
	return response.json();
}

export async function getOffices() {
	let offices = await store.getItem("data");
	let cacheTime = await store.getItem("cacheTime");

	const valid = !!offices && cacheTime && cacheTime + Config.API.USER_OFFICES.CACHE > Date.now();
	if (!valid && navigator.onLine) {
		({ offices } = await loadOffices());
		await store.setItem("data", offices);
		await store.setItem("cacheTime", Date.now());
	}
	if (!valid && !navigator.onLine) {
		throw new OutdatedError("office");
	}
	if (!offices) {
		throw new Response("", {
			status: 500,
			statusText: "Offices data is not available",
		});
	}
	offices.forEach((office) => {
		office.kundenliste ??= [];
	});
	return offices;
}

export async function getCurrentOffice() {
	const officeId = (await getSetting("officeId"))?.toString();
	const offices = await getOffices();
	return (await offices.find((office) => office.ID.toString() === officeId)) ?? null;
}

export async function getOffice(rawOfficeId) {
	const offices = await getOffices();
	const officeId = rawOfficeId.toString();
	return (await offices.find((office) => office.ID.toString() === officeId)) ?? null;
}

export async function clearOffices() {
	return store.clear();
}
